import React from 'react'
import { WrapperContext } from '../context/WrapperContext';

const WhatCompoToShow = ({children,...props}) => {  
  return (
    <WrapperContext.Provider value={ props }>
      <div>{children}</div>
    </WrapperContext.Provider>
  );
}
export default WhatCompoToShow